export default {
    'appointment_reminder': 'Dear {patient}, this is a reminder of your appointment with {doctor} at {facility} on {date} at {time}. Token {token}.',
    'appointment_booked': 'Dear {patient}, your appointment with {doctor} at {facility} is booked for {date} at {time}.',
    'appointment_cancelled': 'Dear {patient}, your appointment at {facility} on {date} has been cancelled.',
    'report_ready': 'Dear {patient}, your {report} report from {facility} is ready.',
    'portal_otp': 'Your {facility} code is {code}. It expires in {minutes} minutes.',
    'payment_received': 'Dear {patient}, {facility} received {amount}. Receipt {receipt}.',
    'staff_alert.critical_lab': 'Critical result for {patient} (bed {bed}): {test} {value}',
    'staff_alert.critical_radiology': 'Critical imaging finding for {patient} (bed {bed}): {study}',
    'staff_alert.consult_request': '{author} referred {patient} to you: {reason}',
    'staff_alert.order_created': 'New order for {patient} (bed {bed}) from {author}: {order}',
    'staff_alert.order_stopped': 'Order stopped for {patient} (bed {bed}) by {author}: {order}',
    'staff_alert.order_held': 'Order held for {patient} (bed {bed}) by {author}: {order}',
    'staff_alert.bell': 'Alerts',
    'staff_alert.unread': 'Alerts waiting: {count}',
    'staff_alert.empty': 'No alerts for you right now',
    'staff_alert.acknowledge': 'Acknowledge',
    'staff_alert.dismiss': 'Dismiss',
    'staff_alert.snooze': 'Snooze',
    'staff_alert.snooze_minutes': '{minutes} minutes',
    'staff_alert.open': 'Open',
    'staff_alert.more': '+{count} more',
    'staff_alert.show_all': 'Show all alerts',
    'staff_alert.load_more': 'Load more',
    'staff_alert.acked_by': 'Acknowledged by {name}',
    'staff_alert.acked': 'Acknowledged on the ward',
    'staff_alert.severity.info': 'Information',
    'staff_alert.severity.warning': 'Warning',
    'staff_alert.severity.critical': 'Critical',
    'staff_alert.via_ward': 'Ward alert',
    'staff_alert.hide_others': 'Hide non-critical',
    'staff_alert.show_hidden': 'Show hidden alerts',
    'staff_alert.could_not_update': 'Could not update the alert',
    'staff_alert.settings.title': 'Staff alert text messages',
    'staff_alert.settings.enable': 'Text the recipients when a critical alert is not acknowledged in time',
    'staff_alert.settings.hint': 'Off by default. Each text uses SMS credits: one message to every recipient with a phone number on file.',
    'staff_alert.settings.delay': 'Minutes to wait before texting',
    'staff_alert.settings.saved': 'Alert settings saved',
    'staff_alert.settings.could_not_save': 'Could not save the alert settings',
    'staff_alert.tasks_overdue': 'Tasks not done for {patient} (bed {bed}): {count}, the oldest due {late} min ago - {tasks}',
};
//# sourceMappingURL=notifications.js.map